module.exports = __webpack_public_path__ + "static/media/sideBarGreyhound.da796656.svg";